import { useContext, useEffect, useState } from 'react';

import {
  Grid,
  Select,
  MenuItem,
  ListItemText,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
  useTheme,
} from '@mui/material';

import { Facebook, WhatsApp, Instagram } from '@mui/icons-material';

import api from '../../services/api';
import { AuthContext } from '../../context/Auth/AuthContext';
import { i18n } from '../../translate/i18n';
import { getStyled } from './styles';

const ConfirmationModal = ({
  title,
  children,
  open,
  onClose,
  onConfirm,
  isCellPhone,
  onSave,
}) => {
  const theme = useTheme();
  const classes = getStyled(theme);
  const [selectedWhatsapp, setSelectedWhatsapp] = useState('');
  const [whatsapps, setWhatsapps] = useState([]);
  const { user } = useContext(AuthContext);
  const { companyId } = user;

  useEffect(() => {
    if (!open) return;

    const fetchWhatsapps = async () => {
      try {
        const { data } = await api.get(`/whatsapp`, {
          params: { companyId },
        });
        setWhatsapps(data);
      } catch (err) {
        console.error('Erro ao buscar conexões:', err);
      }
    };

    fetchWhatsapps();
  }, [open, companyId]);

  const IconChannel = (channel) => {
    switch (channel) {
      case 'facebook':
        return (
          <Facebook style={{ color: '#3b5998', verticalAlign: 'middle' }} />
        );
      case 'instagram':
        return (
          <Instagram style={{ color: '#e1306c', verticalAlign: 'middle' }} />
        );
      case 'whatsapp':
        return (
          <WhatsApp style={{ color: '#25d366', verticalAlign: 'middle' }} />
        );
      default:
        return 'error';
    }
  };

  return (
    <Dialog
      open={open}
      onClose={() => onClose(false)}
      aria-labelledby='confirm-dialog'
    >
      <DialogTitle id='confirm-dialog' sx={theme.custom.dialogColor}>
        {title}
      </DialogTitle>
      <DialogContent dividers sx={theme.custom.dialogColor}>
        <Typography>{children}</Typography>
        {isCellPhone && (
          <Grid style={{ width: 300, marginTop: 10 }} container>
            <Grid size={{ xs: 12 }} item>
              <Select
                sx={theme.custom.selectField}
                required
                fullWidth
                displayEmpty
                variant='outlined'
                value={selectedWhatsapp}
                onChange={(e) => {
                  setSelectedWhatsapp(e.target.value);
                }}
                MenuProps={{
                  anchorOrigin: {
                    vertical: 'bottom',
                    horizontal: 'left',
                  },
                  transformOrigin: {
                    vertical: 'top',
                    horizontal: 'left',
                  },
                  getcontentanchorel: null,
                  ...theme.custom.menuProps,
                }}
                renderValue={() => {
                  if (selectedWhatsapp === '') {
                    return 'Selecione uma Conexão';
                  }
                  const whatsapp = whatsapps.find(
                    (w) => w.id === selectedWhatsapp,
                  );
                  return whatsapp?.name;
                }}
              >
                {whatsapps?.length > 0 &&
                  whatsapps.map((whatsapp, key) => (
                    <MenuItem dense key={key} value={whatsapp.id}>
                      <ListItemText
                        primary={
                          <>
                            {IconChannel(whatsapp.channel)}
                            <Typography
                              component='span'
                              style={{
                                fontSize: 14,
                                marginLeft: '10px',
                                display: 'inline-flex',
                                alignItems: 'center',
                                lineHeight: '2',
                              }}
                            >
                              {whatsapp.name} &nbsp;{' '}
                              <p
                                style={
                                  whatsapp.status === 'CONNECTED'
                                    ? classes.online
                                    : classes.offline
                                }
                              >
                                ({whatsapp.status})
                              </p>
                            </Typography>
                          </>
                        }
                      />
                    </MenuItem>
                  ))}
              </Select>
            </Grid>
          </Grid>
        )}
      </DialogContent>
      <DialogActions sx={theme.custom.dialogColor}>
        <Button
          variant='outlined'
          onClick={() => onClose(false)}
          sx={theme.custom.cancelButton}
        >
          {i18n.t('confirmationModal.buttons.cancel')}
        </Button>
        <Button
          variant='outlined'
          onClick={() => {
            if (isCellPhone) {
              onSave(selectedWhatsapp);
            }
            onConfirm();
            onClose(false);
          }}
          sx={theme.custom.confirmButton}
        >
          {i18n.t('confirmationModal.buttons.confirm')}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ConfirmationModal;
